import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.scout-report-point-form', () => {
  import('./internal/scout-report-point-form').then(({ default: Component }) => Component());
});
